<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>商品分类</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="fetchList">
            <el-table-column prop="categoryId" label="ID">
            </el-table-column>
            <el-table-column prop="name" label="分类名称">
            </el-table-column>
            <el-table-column prop="description" label="描述">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="分类图片" width="180">
                <img :src="row.picUrl" class="user-pic" />
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="创建时间">
                <span>{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="150" label="操作">
                <span>
                            <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                        	<!-- <el-button @click="handleDelete($index, row)" type="text" size="small">删除</el-button> -->
                        </span>
            </el-table-column>
        </el-table>
    
        <el-dialog title="新建分类" v-model="addCategory">
            <el-form :model="categoryForm" ref="categoryForm" :rules="addCategoryRules" label-width="120px">
                <el-form-item label="分类名称" label-width="120px" prop="name">
                    <el-input v-model="categoryForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="分类描述" label-width="120px" prop="description">
                    <el-input v-model="categoryForm.description" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="上传banner图" label-width="120px" prop="picUrl">
                    <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="uptoken">
                        <img v-if="categoryForm.picUrl" :src="categoryForm.picUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addCategory = false">取 消</el-button>
                    <el-button type="primary" @click="handleNewCategory">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
        <el-dialog title="编辑分类" v-model="editCategory">
            <el-form :model="categoryForm" ref="categoryForm" :rules="addCategoryRules" label-width="120px">
                <el-form-item label="分类名称" label-width="120px" prop="name">
                    <el-input v-model="categoryForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="分类描述" label-width="120px" prop="description">
                    <el-input v-model="categoryForm.description" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="上传banner图" label-width="120px" prop="picUrl">
                    <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="uptoken">
                        <img v-if="categoryForm.picUrl" :src="categoryForm.picUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button @click="editCategory = false">取 消</el-button>
                    <el-button type="primary" @click="handleUpdateCategory">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getProductCategories,
        putProductCategories,
        patchProductCategories,
        deleteProductCategories
    } from '../../api/version'
    
    export default {
        data() {
            return {
                fetchList: [],
                addCategory: false,
                editCategory: false,
                uptoken: {
                    token: sessionStorage.token
                },
                categoryForm: {
                    name: '',
                    description: '',
                    picUrl: ''
                },
                picUrl: '',
                addCategoryRules: {
                    name: [{
                        required: true,
                        message: '请输入分类名称',
                        trigger: 'blur'
                    }],
                    description: [{
                        required: true,
                        message: '请输入分类描述',
                        trigger: 'blur'
                    }],
                    picUrl: [{
                        reuqired: true,
                        message: '请上传分类图片',
                        trigger: 'blur'
                    }]
                }
            }
        },
    
        created() {
            //获取商品分类
            getProductCategories().then(res => {
                this.fetchList = res.data
            }, err => {
                console.log(err)
            })
        },
    
        methods: {
            //删除分类
            handleDelete(index, row) {
                //index 索引
                // row 当前数据
                this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fetchList.splice(index, 1)
    
                    deleteProductCategories(row.categoryId, sessionStorage.userId).then(res => {
                        if (res.data.count) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    }, err => {
                        this.$message.error('删除分类失败');
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //编辑分类
            handleEdit(index, row) {
                this.editCategory = true
                this.categoryForm = row
            },
            handleAdd() {
                //新建分类按钮
                this.categoryForm = {
                    name: '',
                    description: '',
                    picUrl: ''
                }
                this.addCategory = true
            },
            //编辑分类
            handleUpdateCategory() {
                this.$refs['categoryForm'].validate((valid) => {
                    if (this.categoryForm.picUrl) {
                        let data = JSON.parse(JSON.stringify(this.categoryForm))
                        delete data.categoryId
                        patchProductCategories(this.categoryForm.categoryId, sessionStorage.userId, data).then(res => {
                            //返回新增数据，插入表格中。
                            // this.fetchList.push(res.data)
                            this.editCategory = false
                        }, err => {
                            this.$message.error('新增分类失败');
                        })
                    } else {
                        this.$message.error('请上传分类图片');
                    }
                })
            },
            handleNewCategory() {
                //新建分类提交按钮
                this.$refs['categoryForm'].validate((valid) => {
                    if (this.categoryForm.picUrl) {
                        this.categoryForm.isOnline = true
                        putProductCategories(sessionStorage.userId, this.categoryForm).then(res => {
                            //返回新增数据，插入表格中。
                            this.fetchList.push(res.data)
                            this.addCategory = false
                        }, err => {
                            this.$message.error('新增分类失败');
                        })
                    } else {
                        this.$message.error('请上传分类图片');
                    }
                })
            },
    
            //图片上传
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                this.uptoken = {
                    token: sessionStorage.token
                }
    
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleAvatarSuccess(res, file) {
                this.categoryForm.picUrl = `https://img.shareplay.cc/${res.key}`
            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// ProductClassify.vue?6c63f26d